import bold from '@monksflow/monks-ui/fonts/HelveticaNowforMonks-Bold.woff2?url';
import extraBold from '@monksflow/monks-ui/fonts/HelveticaNowforMonks-ExtXBd.woff2?url';
import light from '@monksflow/monks-ui/fonts/HelveticaNowforMonks-Light.woff2?url';
import medium from '@monksflow/monks-ui/fonts/HelveticaNowforMonks-TextMd.woff2?url';
import regular from '@monksflow/monks-ui/fonts/HelveticaNowforMonks.woff2?url';

const FONTS = [
  [300, light],
  [400, regular],
  [500, medium],
  [700, bold],
  [800, extraBold],
] as const;

/** Tessra's font faces with absolute URLs: a frame's srcdoc resolves nothing relative to the app. */
export function widgetFontFaces(origin: string): string {
  return FONTS.map(
    ([weight, url]) =>
      `@font-face{font-family:'Helvetica Now for Monks';font-weight:${weight};font-display:swap;src:url('${new URL(url, origin).href}') format('woff2')}`,
  ).join('');
}
